import styled, { css } from 'styled-components'
import TextField from '@mui/material/TextField'

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
`

export const Form = styled.div`
  max-width: 564px;
  width: 100%;
`

export const Input = styled(TextField)`
  
  @media (min-width: 768px) {
    ${props => props.firstChild && css`
      &.MuiFormControl-fullWidth {
        width: calc(100% - 10px);
        margin-right: 10px;
      }
    `}
    ${props => props.lastChild && css`
      &.MuiFormControl-fullWidth {
        width: calc(100% - 10px);
        margin-left: 10px;
      }
    `}
  }
`

export const Text = styled.span`
  display: block;
  margin-bottom: 30px;
  color: #202020;
  letter-spacing: 0.15px;
`

export const Control = styled.div`
  display: flex;
  align-items: flex-start;

  ${props => props.type !== 'input' && css`
    margin-bottom: 30px;
  `}

  ${props => props.type === 'input' && css`
    @media (max-width: 767px) {
      flex-direction: column;
    }
  `}
`

export const Label = styled.label`
  margin-left: 12px;
  color: #202020;
  letter-spacing: 0.15px;
  line-height: 24px;

  ${props => props.firstChild && css`
    margin-right: 24px;
  `}
`

export const BoxImage = styled.div`
  @media (min-width: 1024px) {
    padding-left: 90px;
  }
`

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`

export const Footer = styled.div`
  .button-back {
    margin-right: 20px;
  }

  @media (max-width: 350px) {
    .btn-plan {
      width: 45%;
    }
  }
`

export const Hr = styled.hr`
  height: 1px;
  margin-top: 10px;
  margin-bottom: 30px;
  border: none;
  background: rgba(0, 0, 0, 0.12);
`
